import type { Release } from '../../../types';

const flashOfEnergy: Release = {
  name: 'flash of energy',
  short_description: 'High-Energy Synthesis & Early IDM EP',
  description:
    "Flash of Energy captures the vibrant, exploratory roots of joev's electronic sound. Packed with bright synthesizer arpeggios, driving rhythmic structures, and hypnotic melodic hooks across 5 tracks ('flash of energy', 'a look-alike', 'hunt', 'freedom', 'reprise'), this early release laid the groundwork for joev's distinctive musical journey.",
  tracklist: [
    {
      trackname: 'flash of energy',
      duration: '04:58 min',
      tracknr: '01',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/flash-of-energy',
      },
    },
    {
      trackname: 'a look-alike',
      duration: '03:21 min',
      tracknr: '02',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/a-look-alike',
      },
    },
    {
      trackname: 'hunt',
      duration: '04:10 min',
      tracknr: '03',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/hunt',
      },
    },
    {
      trackname: 'freedom',
      duration: '05:43 min',
      tracknr: '04',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/freedom',
      },
    },
    {
      trackname: 'reprise',
      duration: '03:40 min',
      tracknr: '05',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/reprise',
      },
    },
  ],
  date: '05-2012',
  bgColor: '#3f423c',
  cover: 'joevnoise_flash-of-energy.png',
  detail_link: 'flash-of-energy',
  links: [
    {
      bandcamp: 'https://joev.bandcamp.com/album/flash-of-energy-ep',
    },
    {
      soundcloud: 'https://soundcloud.com/joevnoise/sets/flash-of-energy-ep',
    },
  ],
};

export default flashOfEnergy;
